<template>
  <div class="h5-refound-item-wrap">
    <div class="order-top">
      <div>
        <p class="charge-at">退款单号：{{ refundInfo.refund_order_no }}</p>
      </div>
      <p class="tips" v-if="refundInfo.reply_result">
        {{ replyResult[refundInfo.reply_result] }}
      </p>
    </div>
    <div class="order-bottom">
      <div class="left-wrap">
        <div v-for="item in refundInfo.goods || []" :key="item.goods_id">
          <div class="course-item">
            <img
              class="cover"
              :src="
                handleImageUrl(item.goods_cover_url) + '?imageView2/0/w/340'
              "
              alt=""
            />
            <div class="course-info">
              <p class="title">
                {{ item.goods_title }}
              </p>
              <p v-if="false" class="course-id">ID：{{ item.course_id }}</p>
            </div>
            <button
              v-if="false"
              @click="showUseDetail(item)"
              class="primary-btn"
            >
              使用详情
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="item-bottom">
      <!-- 订单总价 -->
      <div class="operate-wrap">
        <div class="total-price-wrap">
          <p class="total-price">
            全额退款：{{ formatPrice(refundInfo.refund_cash) }}
          </p>
        </div>
        <button
          @click="showRefundDetail(refundInfo)"
          class="primary-btn show-detail"
        >
          查看详情
        </button>
      </div>
      <p class="order-no">交易单号：{{ refundInfo.order_no }}</p>
      <p class="created-at">
        支付时间：{{
          moment(refundInfo.charge_at * 1000).format("YYYY-MM-DD HH:mm:ss")
        }}
        ({{ payType[refundInfo.channel] || "-" }})
      </p>
    </div>
  </div>
</template>

<script>
import { handleImageUrl } from "@saas/components/src";
import { REFUND_STATUS, PAY_TYPE } from "@saas/components/src/constants";
import moment from "moment";
export default {
  props: {
    refundInfo: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      handleImageUrl,
      moment,
      payType: PAY_TYPE,
      refundStatus: REFUND_STATUS,
      replyResult: {
        1: "待机构处理",
        2: "退款完成",
        3: "退款失败",
      },
    };
  },
  methods: {
    formatPrice(val) {
      if (val) {
        return "￥" + (val / 100).toFixed(2);
      } else {
        return "-";
      }
    },
    showUseDetail(obj) {
      const data = { ...this.refundInfo, ...obj };
      this.$emit("showUseDetail", data);
    },
    showRefundDetail(obj) {
      obj.sub_order_list = obj.goods || [];
      this.$emit("showRefundDetail", obj);
    },
  },
};
</script>

<style lang="scss" scoped>
.h5-refound-item-wrap {
  .item-bottom {
    padding: 0.27rem 0.32rem;
    border-top: 1px solid var(--border-subtle, #efefef);
    .operate-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    font-weight: 400;
    font-size: 0.37rem;
    color: var(--text-secondary, #515350);
    line-height: 0.53rem;
    .order-no,
    .created-at {
      margin-top: 0.15rem;
    }
    .total-price-wrap {
      display: flex;
      align-items: center;
    }
  }

  width: 9.36rem;
  background: var(--card-bg, #ffffff);
  border-radius: 0.32rem;
  border: 1px solid var(--border-subtle, #efefef);
  margin-bottom: 0.21rem;
  .order-top {
    background: var(--input-bg, #{$saas-bg-color});
    padding: 0.21rem 0.32rem;
    display: flex;
    // flex-direction: column;
    justify-content: space-between;
    border-bottom: 1px solid var(--border-subtle, #efefef);
    .charge-at {
      color: var(--text-primary, #{$saas-text-color});
      font-size: 0.37rem;
      line-height: 0.53rem;
    }
    .order-no {
      color: var(--text-secondary, #60625f);
      font-size: 0.37rem;
      line-height: 0.53rem;
    }
    .created-at,
    .tips {
      color: var(--text-secondary, #747573);
      font-size: 0.37rem;
      line-height: 0.53rem;
    }
  }
  .order-bottom {
    padding: 0 0.32rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .left-wrap {
      width: 100%;
    }
    .right-wrap {
      width: 100%;
      // width: 480px;
      display: flex;
      // justify-content: space-between;
    }
    .refund-info {
      display: flex;
      align-items: center;
      .tips {
        font-weight: 400;
        font-size: 12px;
        color: var(--text-primary, #{$saas-text-color});
      }
    }
  }
  // 单个课
  .course-item {
    display: flex;
    border-bottom: 1px solid var(--border-subtle, #efefef);
    padding: 16px 0;
    &:last-child {
      border-bottom: none;
    }
    .cover {
      width: 2.81rem;
      height: 1.58rem;
      object-fit: cover;
      margin-right: 0.15rem;
      border-radius: 0.13rem;
    }
    .course-info {
      height: 1.58rem;
      // width: 254px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: start;
      // margin-right: 50px;
    }
    .title {
      font-weight: 600;
      font-size: 0.37rem;
      color: var(--text-primary, #0d1400);
      line-height: 0.53rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-break: anywhere;
    }
    .course-id {
      font-size: 12px;
      color: var(--text-secondary, #747573);
      line-height: 17px;
    }
  }

  // .total-price-wrap {
  //   display: flex;
  //   align-items: center;
  //   .total-price {
  //     font-weight: 400;
  //     font-size: 12px;
  //     color: $saas-text-color;
  //     line-height: 17px;
  //     text-align: center;
  //   }
  //   .channel {
  //     // padding-top: 5px;
  //     font-size: 12px;
  //     color: #747573;
  //     line-height: 17px;
  //     text-align: center;
  //   }
  // }
  .refund-price-wrap {
    width: 100px;
    margin-left: 25px;
    .total-price {
      font-weight: 500;
      font-size: 16px;
      color: var(--text-primary, #{$saas-text-color});
      line-height: 22px;
      text-align: center;
    }
    .refund-tips {
      // padding-top: 5px;
      font-size: 12px;
      color: var(--text-primary, #{$saas-text-color});
      line-height: 17px;
      text-align: center;
    }
  }
  .channel,
  .refund-tips {
    // padding-top: 5px;
    font-size: 12px;
    color: var(--text-secondary, #747573);
    line-height: 17px;
    text-align: center;
  }

  // 状态
  .order-status {
    span {
      display: inline-block;
      width: 90px;
    }
    text-align: right;
  }
  .primary-btn {
    font-size: 12px;
    color: #00c89d;
    line-height: 17px;
    // padding: 5px;
  }
  .cancel-btn {
    font-size: 12px;
    color: var(--text-secondary, #515350);
    line-height: 17px;
    padding: 5px;
  }
  .show-detail {
    width: 1.88rem;
    height: 0.72rem;
    border-radius: 0.16rem;
    border: 0.03rem solid var(--border-subtle, #efefef);
    font-weight: 400;
    font-size: 0.37rem;
    color: var(--text-secondary, #515350);
    line-height: 0.53rem;
  }
}
</style>
